import { render, staticRenderFns } from "./MetricSvg.vue?vue&type=template&id=f7d982e2&"
import script from "./MetricSvg.vue?vue&type=script&lang=ts&"
export * from "./MetricSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports